import { useCustomTheme } from '@/core/theme'
import { CustomTabs } from '@atbay/cyber-components'
import { Wrapper } from '@ui/drawer/caseDetails/components/caseTabs/caseTabs.styles'
import CaseTabCommunication from '@ui/drawer/serviceRequestDetails/components/serviceRequestTabs/caseTabCommunication/caseTabCommunication'

interface Props {
    serviceRequestData: any
}

const ServiceRequestTabs = ({ serviceRequestData }: Props) => {
    const theme = useCustomTheme()
    const [selectedTab, setSelectedTab] = useState('communication')

    useEffect(() => {
        setSelectedTab('communication')
    }, [serviceRequestData])

    const tabList = [
        {
            key: 'communication',
            label: 'Communication',
        },
    ]

    return (
        <Wrapper>
            <CustomTabs
                onTabChange={setSelectedTab}
                activeKey={selectedTab}
                items={tabList}
                activeStyles={{ color: theme.colors.greys[600] }}
                inactiveStyles={{
                    color: theme.colors.greys[600],
                }}
            />
            {
                {
                    communication: (
                        <CaseTabCommunication data={serviceRequestData} />
                    ),
                }[selectedTab]
            }
        </Wrapper>
    )
}

export default ServiceRequestTabs
